export default __webpack_public_path__ + "static/media/DNA325.0cb17088.png";